import React, { useState } from "react";
import { motion } from "framer-motion";
import Title from "../layouts/Title";
import ProjectsCard from "./ProjectsCard";

/* ---------------- POWER BI PROJECTS ---------------- */
const powerBIProjects = [
  { title: "Sales Management Report", src: "/images/projects/PowerBI/1Sales.png", github: null, live: "https://app.fabric.microsoft.com/view?r=eyJrIjoiYzQ3NTIzOGItNGY5Ni00NjA5LWEyYTktZTJlY2I0OWUxOWZmIiwidCI6ImM3NDI3YTAwLTkyY2EtNDZiZS1iZWE5LWIwMTc3NDlkNzRkMSJ9" },
  { title: "Personal Finance Report", src: "/images/projects/PowerBI/2MyFinance.png", github: null, live: "https://app.powerbi.com/view?r=eyJrIjoiODg0YjU2OGYtNmJmOS00NDJjLTg1ZWMtNGUyNDVhNTcyM2EyIiwidCI6ImM3NDI3YTAwLTkyY2EtNDZiZS1iZWE5LWIwMTc3NDlkNzRkMSJ9" },
  { title: "Human Resource Analytics Report", src: "/images/projects/PowerBI/3HR.png", github: null, live: "https://app.powerbi.com/view?r=eyJrIjoiODU0MjM1M2EtOWVlOC00ZDFmLWE2MTAtYTdkMzkwMTMzOTQ5IiwidCI6ImM3NDI3YTAwLTkyY2EtNDZiZS1iZWE5LWIwMTc3NDlkNzRkMSJ9" },
  { title: "Pizza Sales Analysis Report", src: "/images/projects/PowerBI/4PizzaSales.png", github: null, live: "https://app.powerbi.com/view?r=eyJrIjoiZjY1MWVhOTgtYTAzMi00MGE4LTgzNmItNDQxNjRjYTcyMDYyIiwidCI6ImM3NDI3YTAwLTkyY2EtNDZiZS1iZWE5LWIwMTc3NDlkNzRkMSJ9" },
  { title: "Profit and Loss Report", src: "/images/projects/PowerBI/5Profit&Loss.png", github: null, live: "https://app.powerbi.com/view?r=eyJrIjoiNjNhMWM5OTYtYmUyNC00ZmQwLTlhNjItN2UwMGQzZmNmMTc5IiwidCI6ImM3NDI3YTAwLTkyY2EtNDZiZS1iZWE5LWIwMTc3NDlkNzRkMSJ9" },
  { title: "Mexico Toy Sales Report", src: "/images/projects/PowerBI/6Mexico&Toy.png", github: null, live: "https://app.powerbi.com/view?r=eyJrIjoiNzU0M2EyNGUtYTEyYy00ZDgzLWI0MzctNmUzMDQ2ZmIxZTFiIiwidCI6ImM3NDI3YTAwLTkyY2EtNDZiZS1iZWE5LWIwMTc3NDlkNzRkMSJ9" },
  { title: "ATLIQ Business Report", src: "/images/projects/PowerBI/7Atliq.png", github: "#", live: "https://app.powerbi.com/view?r=eyJrIjoiMjM3MmQxNjQtZWQ5MC00ODMzLWE5NzktOWIwMDdiM2FlODE5IiwidCI6ImM3NDI3YTAwLTkyY2EtNDZiZS1iZWE5LWIwMTc3NDlkNzRkMSJ9&pageName=ReportSection9d5d0d2e0aa2666e456e" },
  { title: "Christmas Sales & Trends Report", src: "/images/projects/PowerBI/8Xmas.png", github: null, live: "https://app.powerbi.com/view?r=eyJrIjoiYjYwZTAzYWEtMjZkZi00NjM1LTgwNjQtZjhlNDY5OTMzZGFlIiwidCI6ImM3NDI3YTAwLTkyY2EtNDZiZS1iZWE5LWIwMTc3NDlkNzRkMSJ9" },
];

/* ---------------- SQL PROJECTS ---------------- */
const sqlProjects = [
  { title: "Netflix Analytics", src: "/images/projects/SQL/Netflix.jpg", github: "https://github.com/TheBIDeveloper/Netflix_SQL_Project", live: null },
  { title: "Covid-19 Case Study", src: "/images/projects/SQL/Covid19.jpg", github: "https://github.com/TheBIDeveloper/Covid19_SQL_Project", live: null },
  { title: "FIFA Case Study", src: "/images/projects/SQL/FIFA.jpg", github: "https://github.com/TheBIDeveloper/FIFA_SQL_Project", live: null },
  { title: "Sales Performance Analytics", src: "/images/projects/SQL/SalesP.png", github: "https://github.com/TheBIDeveloper/Sales_Analytics_SQL_Project", live: null },
  { title: "Zomato Business Analytics", src: "/images/projects/SQL/Zomato.png", github: "https://github.com/TheBIDeveloper/Zomato-Analytics-Advanced-SQL-Business-Intelligence-Project", live: null },
  { title: "Instagram Analytics", src: "/images/projects/SQL/Instagram.jpg", github: "https://github.com/TheBIDeveloper/Instagram_Analytics_SQL_Project", live: null },
  { title: "Consumer Goods Sales & Market Analytics", src: "/images/projects/SQL/Consumer.png", github: "https://github.com/TheBIDeveloper/Consumer_Analytics_SQL_Project", live: null },
  { title: "Music Trends & Streaming Analytics", src: "/images/projects/SQL/Music.jpg", github: "https://github.com/TheBIDeveloper/Music_Data_Analytics_SQL_Project", live: null },
  { title: "Walmart Inventory & Sales Analytics", src: "/images/projects/SQL/Walmart.jpg", github: "https://github.com/TheBIDeveloper/Walmart_Inventory_SQL_Project", live: null },
  { title: "Global Population Analytics", src: "/images/projects/SQL/Population.png", github: "https://github.com/TheBIDeveloper/World_Population_SQL_Project", live: null },
  { title: "Airline Flight Delay & Performance Analytics", src: "/images/projects/SQL/Airplane.jpg", github: "https://github.com/TheBIDeveloper/Airline-Flight-Delay-SQL-Project", live: null },
  { title: "Chocolate Sales & Customer Analytics", src: "/images/projects/SQL/Choclate.jpg", github: "https://github.com/TheBIDeveloper/Awesome-Chocolate-Sales-SQL-Project", live: null },
  { title: "Road Accident Analytics & Safety Insights", src: "/images/projects/SQL/RoadA.jpg", github: "https://github.com/TheBIDeveloper/Road-Accident-Analytics-SQL-Project", live: null },
  { title: "Fraud Detection & Analytics", src: "/images/projects/SQL/Frawd.jpg", github: "https://github.com/TheBIDeveloper/Fraud-Analytics-SQL-Project", live: null },
];

/* ---------------- DATA ENGINEERING PROJECTS ---------------- */
const dataEngineeringProjects = [
  { title: "Fabric API‑Based Data Engineering Pipeline", src: "/images/projects/DataEngineering/1.png", github: "https://github.com/TheBIDeveloper/Fabric-API-Based-Data-Engineering-Pipeline", live: null },
  { title: "Automated Data Orchestration with Fabric Pipelines", src: "/images/projects/DataEngineering/2.png", github: "https://github.com/TheBIDeveloper/Automated-Data-Orchestration-with-Fabric-Pipelines", live: null },
  { title: "Lakehouse & Medallion Architecture in Fabric", src: "/images/projects/DataEngineering/3.png", github: "https://github.com/TheBIDeveloper/Lakehouse-Medallion-Architecture-in-Fabric", live: null },
];

/* ---------------- MAIN PROJECTS COMPONENT ---------------- */
const Projects = () => {
  const [active, setActive] = useState("powerbi");

  const projectMap = {
    powerbi: powerBIProjects,
    sql: sqlProjects,
    dataeng: dataEngineeringProjects,
  };

  return (
    <section id="projects" className="w-full py-20 border-b border-black">
      <div className="flex justify-center text-center mb-6">
        <Title
          title="VISIT MY PORTFOLIO AND SHARE YOUR FEEDBACK"
          des="My Projects"
        />
      </div>

      {/* Category Buttons */}
      <div className="flex justify-center gap-4 mb-14 flex-wrap">
        {[
          { id: "powerbi", label: "Power BI" },
          { id: "sql", label: "SQL" },
          { id: "dataeng", label: "Data Engineering" },
        ].map((tab) => (
          <motion.button
            key={tab.id}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.97 }}
            onClick={() => setActive(tab.id)}
            className={`px-6 py-3 rounded-full transition-all duration-300 ${
              active === tab.id
                ? "bg-designColor text-black shadow-lg shadow-designColor/30"
                : "bg-gray-900 text-gray-300 hover:bg-gray-800 hover:text-white"
            }`}
          >
            {tab.label}
          </motion.button>
        ))}
      </div>

      {/* Projects Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
        {projectMap[active].map((project, index) => (
          <motion.div
            key={index}
            whileHover={{ y: -8 }}
            transition={{ duration: 0.25, ease: "easeOut" }}
          >
            <ProjectsCard
              title={project.title}
              src={project.src}
              github={active === "powerbi" ? null : project.github}
              live={project.live}
              isPowerBI={active === "powerbi"} // Custom prop for rectangle
            />
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Projects;
